import VueFormulate from '@braid/vue-formulate';
import { de } from '@braid/vue-formulate-i18n';
import Vue from 'vue';
import FormulateDropzonePlugin from '../Formulate/FormulateDropzone/plugin';
import FormulateMultiselectPlugin from '../Formulate/FormulateMultiselect/plugin';
import FormulateMaskedInputPlugin from '../Formulate/FormulateMaskedInput/plugin';
import { messages, rules } from './validation-rules';

const isBoxElement = (context) => ['checkbox', 'radio'].includes(context.type);
const isBoxType = (context) => context.classification === 'box';
const isBox = (context) => isBoxElement(context) && isBoxType(context);
const isGroup = (context) =>
  context.type === 'group' && context.classification === 'group';

Vue.use(VueFormulate, {
  plugins: [
    de,
    FormulateMultiselectPlugin,
    FormulateDropzonePlugin,
    FormulateMaskedInputPlugin,
  ],
  locale: 'de',
  locales: {
    de: {
      ...messages,
    },
  },
  useInputDecorators: false,
  rules,
  classes: {
    outer: (context, classes) => {
      if (isGroup(context)) {
        return classes;
      }
      return classes.concat(['form-group']);
    },
    wrapper: (context, classes) => {
      if (isBox(context)) {
        // Special behavior for some checkboxes that shouldn't be rendered as
        // cards.
        if (typeof context.attrs['data-no-card'] !== 'undefined') {
          return classes.concat(['form-check']);
        }
        return classes.concat(['form-check', 'form-check--card']);
      }
      return classes;
    },
    label: (context, classes) => {
      if (isBox(context)) {
        return classes.concat(['form-check-label']);
      }
      return classes.concat(['form-label']);
    },
    input: (context, classes) => {
      if (isBoxElement(context)) {
        if (isBoxType(context)) {
          return classes.concat(['form-check-input']);
        }
        return classes;
      }
      return classes.concat(['form-control']);
    },
    errors: 'invalid-feedback',
    help: (context, classes) => {
      return classes.concat([
        'form-text',
        `form-text--${context.helpPosition || 'none'}`,
      ]);
    },
    inputIsValid: (context, classes) => {
      if (isBoxElement(context)) {
        return classes;
      }
      return classes.concat(['is-valid']);
    },
    inputHasErrors: 'is-invalid',
  },
  slotComponents: {
    // Allow HTML to be rendered inside labels
    label: 'HtmlLabel',
  },
});
